import { EBrowserStorageType } from '@/core/apis/browser_storage_api/browser_storage_api_types';
import { CURR_ENV } from '@/core/constants/appConfig/environment';
import { SESSION_LENGTH_MAP } from '@/core/constants/appConfig/types';
import { TimeUtils } from '@/core/event_logic/utils/time_utils';

import { StorageHandler } from '../storage_handler';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const SESSION_LENGTH = SESSION_LENGTH_MAP[CURR_ENV];

type SessionState = {
  lastActivity: number;
};

const defaultSessionState: SessionState = {
  lastActivity: 0,
};

export class SessionLogicHandler {
  private static readonly _storageHandler = new StorageHandler<SessionState>(
    'sessionState',
    defaultSessionState,
    EBrowserStorageType.LOCALSTORAGE,
  );

  private static async updateLastActivity(): Promise<void> {
    const currentTime = await TimeUtils.getCurrentEpochInSecondsSynced();
    this._storageHandler.set({ lastActivity: currentTime });
  }

  static async isSessionActive(): Promise<boolean> {
    const currentTime = await TimeUtils.getCurrentEpochInSecondsSynced();
    const { lastActivity } = this._storageHandler.get();
    return currentTime - lastActivity <= SESSION_LENGTH && lastActivity !== 0;
  }

  static async DoesNewSessionStart(): Promise<boolean> {
    const isActive = await this.isSessionActive();
    await this.updateLastActivity();
    return !isActive;
  }
}
